export default __webpack_public_path__ + "static/media/rcm-logo.a565c987.svg";